[
	{
		"name": "Pacific/Midway",
		"alternativeName": "American Samoa Time",
		"group": ["Pacific/Midway"],
		"continentName": "Oceania",
		"countryName": "United States Minor Outlying Islands",
		"mainCities": ["Midway"]
	},
	{
		"name": "Pacific/Pago_Pago",
		"alternativeName": "American Samoa Time",
		"group": ["Pacific/Pago_Pago", "US/Samoa", "Pacific/Samoa", "Pacific/Midway"],
		"continentName": "Oceania",
		"countryName": "American Samoa",
		"mainCities": ["Pago Pago"]
	},
	{
		"name": "Pacific/Niue",
		"alternativeName": "Niue Time",
		"group": ["Pacific/Niue"],
		"continentName": "Oceania",
		"countryName": "Niue",
		"mainCities": ["Alofi"]
	},
	{
		"name": "Pacific/Rarotonga",
		"alternativeName": "Cook Islands Time",
		"group": ["Pacific/Rarotonga"],
		"continentName": "Oceania",
		"countryName": "Cook Islands",
		"mainCities": ["Avarua"]
	},
	{
		"name": "America/Adak",
		"alternativeName": "Hawaii-Aleutian Time",
		"group": ["America/Adak", "US/Aleutian", "America/Atka"],
		"continentName": "North America",
		"countryName": "United States",
		"mainCities": ["Adak"]
	},
	{
		"name": "Pacific/Honolulu",
		"alternativeName": "Hawaii-Aleutian Time",
		"group": ["Pacific/Honolulu", "US/Hawaii", "Pacific/Johnston", "HST"],
		"continentName": "North America",
		"countryName": "United States",
		"mainCities": ["Honolulu", "East Honolulu", "Pearl City", "Makakilo / Kapolei / Honokai Hale"]
	},
	{
		"name": "Pacific/Tahiti",
		"alternativeName": "Tahiti Time",
		"group": ["Pacific/Tahiti"],
		"continentName": "Oceania",
		"countryName": "French Polynesia",
		"mainCities": ["Faaa", "Papeete", "Punaauia"]
	},
	{
		"name": "Pacific/Marquesas",
		"alternativeName": "Marquesas Time",
		"group": ["Pacific/Marquesas"],
		"continentName": "Oceania",
		"countryName": "French Polynesia",
		"mainCities": ["Marquesas"]
	},
	{
		"name": "America/Anchorage",
		"alternativeName": "Alaska Time",
		"group": ["America/Anchorage", "America/Juneau", "America/Metlakatla", "America/Nome", "America/Sitka", "America/Yakutat", "US/Alaska"],
		"continentName": "North America",
		"countryName": "United States",
		"mainCities": ["Anchorage", "Fairbanks", "Juneau", "Eagle River"]
	},
	{
		"name": "Pacific/Gambier",
		"alternativeName": "Gambier Time",
		"group": ["Pacific/Gambier"],
		"continentName": "Oceania",
		"countryName": "French Polynesia",
		"mainCities": ["Gambier"]
	},
	{
		"name": "America/Los_Angeles",
		"alternativeName": "Pacific Time",
		"group": ["America/Los_Angeles", "US/Pacific", "PST8PDT"],
		"continentName": "North America",
		"countryName": "United States",
		"mainCities": ["Los Angeles", "San Diego", "San Jose", "San Francisco", "Seattle", "Las Vegas"]
	},
	{
		"name": "America/Tijuana",
		"alternativeName": "Pacific Time",
		"group": ["America/Tijuana", "Mexico/BajaNorte", "America/Ensenada", "America/Santa_Isabel"],
		"continentName": "North America",
		"countryName": "Mexico",
		"mainCities": ["Tijuana", "Mexicali", "Ensenada", "Rosarito"]
	},
	{
		"name": "America/Vancouver",
		"alternativeName": "Pacific Time",
		"group": ["America/Vancouver", "Canada/Pacific"],
		"continentName": "North America",
		"countryName": "Canada",
		"mainCities": ["Vancouver", "Surrey", "Victoria", "Burnaby"]
	},
	{
		"name": "Pacific/Pitcairn",
		"alternativeName": "Pitcairn Time",
		"group": ["Pacific/Pitcairn"],
		"continentName": "Oceania",
		"countryName": "Pitcairn",
		"mainCities": ["Adamstown"]
	},
	{
		"name": "America/Hermosillo",
		"alternativeName": "Mexican Pacific Time",
		"group": ["America/Hermosillo", "America/Mazatlan", "Mexico/BajaSur"],
		"continentName": "North America",
		"countryName": "Mexico",
		"mainCities": ["Hermosillo", "Culiacán", "Mazatlán", "Tepic"]
	},
	{
		"name": "America/Edmonton",
		"alternativeName": "Mountain Time",
		"group": ["America/Cambridge_Bay", "America/Edmonton", "America/Inuvik", "Canada/Mountain", "America/Yellowknife"],
		"continentName": "North America",
		"countryName": "Canada",
		"mainCities": ["Calgary", "Edmonton", "Lethbridge", "Red Deer"]
	},
	{
		"name": "America/Ciudad_Juarez",
		"alternativeName": "Mountain Time",
		"group": ["America/Ciudad_Juarez"],
		"continentName": "North America",
		"countryName": "Mexico",
		"mainCities": ["Ciudad Juárez"]
	},
	{
		"name": "America/Denver",
		"alternativeName": "Mountain Time",
		"group": ["America/Boise", "America/Denver", "MST7MDT", "Navajo", "US/Mountain", "America/Shiprock"],
		"continentName": "North America",
		"countryName": "United States",
		"mainCities": ["Denver", "El Paso", "Albuquerque", "Colorado Springs", "Salt Lake City"]
	},
	{
		"name": "America/Phoenix",
		"alternativeName": "Mountain Time",
		"group": ["America/Phoenix", "MST", "US/Arizona", "America/Creston"],
		"continentName": "North America",
		"countryName": "United States",
		"mainCities": ["Phoenix", "Tucson", "Mesa", "Chandler"]
	},
	{
		"name": "America/Whitehorse",
		"alternativeName": "Yukon Time",
		"group": ["America/Creston", "America/Dawson", "America/Dawson_Creek", "America/Fort_Nelson", "America/Whitehorse", "Canada/Yukon"],
		"continentName": "North America",
		"countryName": "Canada",
		"mainCities": ["Whitehorse", "Fort St. John", "Creston", "Dawson"]
	},
	{
		"name": "America/Belize",
		"alternativeName": "Central Time",
		"group": ["America/Belize"],
		"continentName": "North America",
		"countryName": "Belize",
		"mainCities": ["Belize City", "San Pedro", "Orange Walk", "Belmopan"]
	},
	{
		"name": "America/Chicago",
		"alternativeName": "Central Time",
		"group": [
			"America/Chicago",
			"America/Indiana/Knox",
			"America/Indiana/Tell_City",
			"America/Menominee",
			"America/North_Dakota/Beulah",
			"America/North_Dakota/Center",
			"America/North_Dakota/New_Salem",
			"CST6CDT",
			"US/Central",
			"US/Indiana-Starke",
			"America/Knox_IN"
		],
		"continentName": "North America",
		"countryName": "United States",
		"mainCities": ["Chicago", "Houston", "San Antonio", "Dallas", "Minneapolis", "New Orleans"]
	},
	{
		"name": "America/Guatemala",
		"alternativeName": "Central Time",
		"group": ["America/Guatemala"],
		"continentName": "North America",
		"countryName": "Guatemala",
		"mainCities": ["Guatemala City", "Villa Nueva", "Mixco", "Cobán"]
	},
	{
		"name": "America/Managua",
		"alternativeName": "Central Time",
		"group": ["America/Managua"],
		"continentName": "North America",
		"countryName": "Nicaragua",
		"mainCities": ["Managua", "León", "Masaya", "Chinandega"]
	},
	{
		"name": "America/Mexico_City",
		"alternativeName": "Central Time",
		"group": [
			"America/Bahia_Banderas",
			"America/Chihuahua",
			"America/Merida",
			"America/Mexico_City",
			"America/Monterrey",
			"Mexico/General"
		],
		"continentName": "North America",
		"countryName": "Mexico",
		"mainCities": ["Mexico City", "Iztapalapa", "Puebla", "Ecatepec de Morelos"]
	},
	{
		"name": "America/Matamoros",
		"alternativeName": "Central Time",
		"group": ["America/Matamoros", "America/Ojinaga"],
		"continentName": "North America",
		"countryName": "Mexico",
		"mainCities": ["Reynosa", "Heroica Matamoros", "Nuevo Laredo", "Ciudad Acuña"]
	},
	{
		"name": "America/Costa_Rica",
		"alternativeName": "Central Time",
		"group": ["America/Costa_Rica"],
		"continentName": "North America",
		"countryName": "Costa Rica",
		"mainCities": ["San José", "Limón", "San Francisco", "Alajuela"]
	},
	{
		"name": "America/El_Salvador",
		"alternativeName": "Central Time",
		"group": ["America/El_Salvador"],
		"continentName": "North America",
		"countryName": "El Salvador",
		"mainCities": ["San Salvador", "Soyapango", "San Miguel", "Santa Ana"]
	},
	{
		"name": "America/Regina",
		"alternativeName": "Central Time",
		"group": ["America/Regina", "America/Swift_Current", "Canada/Saskatchewan"],
		"continentName": "North America",
		"countryName": "Canada",
		"mainCities": ["Saskatoon", "Regina", "Prince Albert", "Moose Jaw"]
	},
	{
		"name": "America/Tegucigalpa",
		"alternativeName": "Central Time",
		"group": ["America/Tegucigalpa"],
		"continentName": "North America",
		"countryName": "Honduras",
		"mainCities": ["Tegucigalpa", "San Pedro Sula", "La Ceiba", "Choloma"]
	},
	{
		"name": "America/Winnipeg",
		"alternativeName": "Central Time",
		"group": ["America/Rankin_Inlet", "America/Resolute", "America/Winnipeg", "Canada/Central", "America/Rainy_River"],
		"continentName": "North America",
		"countryName": "Canada",
		"mainCities": ["Winnipeg", "Brandon", "Steinbach", "Kenora"]
	},
	{
		"name": "Pacific/Easter",
		"alternativeName": "Easter Island Time",
		"group": ["Pacific/Easter", "Chile/EasterIsland"],
		"continentName": "South America",
		"countryName": "Chile",
		"mainCities": ["Easter"]
	},
	{
		"name": "Pacific/Galapagos",
		"alternativeName": "Galapagos Time",
		"group": ["Pacific/Galapagos"],
		"continentName": "South America",
		"countryName": "Ecuador",
		"mainCities": ["Galapagos"]
	},
	{
		"name": "America/Rio_Branco",
		"alternativeName": "Acre Time",
		"group": ["America/Eirunepe", "America/Rio_Branco", "Brazil/Acre", "America/Porto_Acre"],
		"continentName": "South America",
		"countryName": "Brazil",
		"mainCities": ["Rio Branco", "Cruzeiro do Sul", "Tarauacá", "Sena Madureira"]
	},
	{
		"name": "America/Bogota",
		"alternativeName": "Colombia Time",
		"group": ["America/Bogota"],
		"continentName": "South America",
		"countryName": "Colombia",
		"mainCities": ["Bogotá", "Cali", "Medellín", "Barranquilla"]
	},
	{
		"name": "America/Havana",
		"alternativeName": "Cuba Time",
		"group": ["America/Havana", "Cuba"],
		"continentName": "North America",
		"countryName": "Cuba",
		"mainCities": ["Havana", "Santiago de Cuba", "Camagüey", "Holguín"]
	},
	{
		"name": "America/Atikokan",
		"alternativeName": "Eastern Time",
		"group": ["America/Atikokan"],
		"continentName": "North America",
		"countryName": "Canada",
		"mainCities": ["Atikokan"]
	},
	{
		"name": "America/Cancun",
		"alternativeName": "Eastern Time",
		"group": ["America/Cancun"],
		"continentName": "North America",
		"countryName": "Mexico",
		"mainCities": ["Cancún", "Chetumal", "Playa del Carmen", "Cozumel"]
	},
	{
		"name": "America/Cayman",
		"alternativeName": "Eastern Time",
		"group": ["America/Cayman"],
		"continentName": "North America",
		"countryName": "Cayman Islands",
		"mainCities": ["George Town", "West Bay"]
	},
	{
		"name": "America/Jamaica",
		"alternativeName": "Eastern Time",
		"group": ["America/Jamaica", "Jamaica"],
		"continentName": "North America",
		"countryName": "Jamaica",
		"mainCities": ["Kingston", "New Kingston", "Spanish Town", "Portmore"]
	},
	{
		"name": "America/Nassau",
		"alternativeName": "Eastern Time",
		"group": ["America/Nassau"],
		"continentName": "North America",
		"countryName": "Bahamas",
		"mainCities": ["Nassau", "Lucaya", "Freeport", "Killarney"]
	},
	{
		"name": "America/New_York",
		"alternativeName": "Eastern Time",
		"group": [
			"America/Detroit",
			"America/Indiana/Indianapolis",
			"America/Indiana/Marengo",
			"America/Indiana/Petersburg",
			"America/Indiana/Vevay",
			"America/Indiana/Vincennes",
			"America/Indiana/Winamac",
			"America/Kentucky/Louisville",
			"America/Kentucky/Monticello",
			"America/New_York",
			"US/Michigan",
			"US/East-Indiana",
			"America/Indianapolis",
			"America/Fort_Wayne",
			"America/Louisville",
			"EST5EDT",
			"US/Eastern"
		],
		"continentName": "North America",
		"countryName": "United States",
		"mainCities": ["New York City", "Brooklyn", "Queens", "Philadelphia", "Washington", "Boston", "Miami", "Atlanta", "Detroit"]
	},
	{
		"name": "America/Panama",
		"alternativeName": "Eastern Time",
		"group": ["America/Panama", "EST", "America/Atikokan", "America/Cayman", "America/Coral_Harbour"],
		"continentName": "North America",
		"countryName": "Panama",
		"mainCities": ["Panamá", "San Miguelito", "Juan Díaz", "David"]
	},
	{
		"name": "America/Port-au-Prince",
		"alternativeName": "Eastern Time",
		"group": ["America/Port-au-Prince"],
		"continentName": "North America",
		"countryName": "Haiti",
		"mainCities": ["Port-au-Prince", "Carrefour", "Delmas", "Port-de-Paix"]
	},
	{
		"name": "America/Grand_Turk",
		"alternativeName": "Eastern Time",
		"group": ["America/Grand_Turk"],
		"continentName": "North America",
		"countryName": "Turks and Caicos Islands",
		"mainCities": ["Providenciales", "Cockburn Town"]
	},
	{
		"name": "America/Toronto",
		"alternativeName": "Eastern Time",
		"group": [
			"America/Iqaluit",
			"America/Toronto",
			"America/Pangnirtung",
			"Canada/Eastern",
			"America/Nassau",
			"America/Montreal",
			"America/Nipigon",
			"America/Thunder_Bay"
		],
		"continentName": "North America",
		"countryName": "Canada",
		"mainCities": ["Toronto", "Montréal", "Ottawa", "Mississauga", "Quebec City"]
	},
	{
		"name": "America/Guayaquil",
		"alternativeName": "Ecuador Time",
		"group": ["America/Guayaquil"],
		"continentName": "South America",
		"countryName": "Ecuador",
		"mainCities": ["Quito", "Guayaquil", "Cuenca", "Santo Domingo de los Colorados"]
	},
	{
		"name": "America/Lima",
		"alternativeName": "Peru Time",
		"group": ["America/Lima"],
		"continentName": "South America",
		"countryName": "Peru",
		"mainCities": ["Lima", "Callao", "Arequipa", "Trujillo"]
	},
	{
		"name": "America/Manaus",
		"alternativeName": "Amazon Time",
		"group": ["America/Boa_Vista", "America/Campo_Grande", "America/Cuiaba", "America/Manaus", "America/Porto_Velho", "Brazil/West"],
		"continentName": "South America",
		"countryName": "Brazil",
		"mainCities": ["Manaus", "Campo Grande", "Cuiabá", "Porto Velho"]
	},
	{
		"name": "America/St_Kitts",
		"alternativeName": "Atlantic Time",
		"group": ["America/St_Kitts"],
		"continentName": "North America",
		"countryName": "Saint Kitts and Nevis",
		"mainCities": ["Basseterre"]
	},
	{
		"name": "America/Blanc-Sablon",
		"alternativeName": "Atlantic Time",
		"group": ["America/Blanc-Sablon"],
		"continentName": "North America",
		"countryName": "Canada",
		"mainCities": ["Blanc-Sablon"]
	},
	{
		"name": "America/Montserrat",
		"alternativeName": "Atlantic Time",
		"group": ["America/Montserrat"],
		"continentName": "North America",
		"countryName": "Montserrat",
		"mainCities": ["Brades", "Plymouth"]
	},
	{
		"name": "America/Barbados",
		"alternativeName": "Atlantic Time",
		"group": ["America/Barbados"],
		"continentName": "North America",
		"countryName": "Barbados",
		"mainCities": ["Bridgetown"]
	},
	{
		"name": "America/Port_of_Spain",
		"alternativeName": "Atlantic Time",
		"group": ["America/Port_of_Spain"],
		"continentName": "North America",
		"countryName": "Trinidad and Tobago",
		"mainCities": ["Chaguanas", "Mon Repos", "San Fernando", "Port of Spain"]
	},
	{
		"name": "America/Martinique",
		"alternativeName": "Atlantic Time",
		"group": ["America/Martinique"],
		"continentName": "North America",
		"countryName": "Martinique",
		"mainCities": ["Fort-de-France", "Le Lamentin", "Le Robert", "Sainte-Marie"]
	},
	{
		"name": "America/St_Lucia",
		"alternativeName": "Atlantic Time",
		"group": ["America/St_Lucia"],
		"continentName": "North America",
		"countryName": "Saint Lucia",
		"mainCities": ["Gros Islet", "Castries"]
	},
	{
		"name": "America/St_Barthelemy",
		"alternativeName": "Atlantic Time",
		"group": ["America/St_Barthelemy"],
		"continentName": "North America",
		"countryName": "Saint Barthelemy",
		"mainCities": ["Gustavia"]
	},
	{
		"name": "America/Halifax",
		"alternativeName": "Atlantic Time",
		"group": ["America/Glace_Bay", "America/Goose_Bay", "America/Halifax", "America/Moncton", "Canada/Atlantic"],
		"continentName": "North America",
		"countryName": "Canada",
		"mainCities": ["Halifax", "Sydney", "Dartmouth", "Moncton"]
	},
	{
		"name": "Atlantic/Bermuda",
		"alternativeName": "Atlantic Time",
		"group": ["Atlantic/Bermuda"],
		"continentName": "North America",
		"countryName": "Bermuda",
		"mainCities": ["Hamilton"]
	},
	{
		"name": "America/St_Vincent",
		"alternativeName": "Atlantic Time",
		"group": ["America/St_Vincent"],
		"continentName": "North America",
		"countryName": "Saint Vincent and the Grenadines",
		"mainCities": ["Kingstown", "Calliaqua"]
	},
	{
		"name": "America/Kralendijk",
		"alternativeName": "Atlantic Time",
		"group": ["America/Kralendijk"],
		"continentName": "North America",
		"countryName": "Bonaire, Saint Eustatius and Saba ",
		"mainCities": ["Kralendijk"]
	},
	{
		"name": "America/Guadeloupe",
		"alternativeName": "Atlantic Time",
		"group": ["America/Guadeloupe"],
		"continentName": "North America",
		"countryName": "Guadeloupe",
		"mainCities": ["Les Abymes", "Baie-Mahault", "Le Gosier", "Petit-Bourg"]
	},
	{
		"name": "America/Marigot",
		"alternativeName": "Atlantic Time",
		"group": ["America/Marigot"],
		"continentName": "North America",
		"countryName": "Saint Martin",
		"mainCities": ["Marigot"]
	},
	{
		"name": "America/Aruba",
		"alternativeName": "Atlantic Time",
		"group": ["America/Aruba"],
		"continentName": "North America",
		"countryName": "Aruba",
		"mainCities": ["Oranjestad", "Noord", "Tanki Leendert", "San Nicolas"]
	},
	{
		"name": "America/Lower_Princes",
		"alternativeName": "Atlantic Time",
		"group": ["America/Lower_Princes"],
		"continentName": "North America",
		"countryName": "Sint Maarten",
		"mainCities": ["Philipsburg"]
	},
	{
		"name": "America/Tortola",
		"alternativeName": "Atlantic Time",
		"group": ["America/Tortola"],
		"continentName": "North America",
		"countryName": "British Virgin Islands",
		"mainCities": ["Road Town"]
	},
	{
		"name": "America/Dominica",
		"alternativeName": "Atlantic Time",
		"group": ["America/Dominica"],
		"continentName": "North America",
		"countryName": "Dominica",
		"mainCities": ["Roseau"]
	},
	{
		"name": "America/St_Thomas",
		"alternativeName": "Atlantic Time",
		"group": ["America/St_Thomas"],
		"continentName": "North America",
		"countryName": "U.S. Virgin Islands",
		"mainCities": ["Saint Croix", "Charlotte Amalie"]
	},
	{
		"name": "America/Grenada",
		"alternativeName": "Atlantic Time",
		"group": ["America/Grenada"],
		"continentName": "North America",
		"countryName": "Grenada",
		"mainCities": ["Saint George's"]
	},
	{
		"name": "America/Antigua",
		"alternativeName": "Atlantic Time",
		"group": ["America/Antigua"],
		"continentName": "North America",
		"countryName": "Antigua and Barbuda",
		"mainCities": ["Saint John’s"]
	},
	{
		"name": "America/Puerto_Rico",
		"alternativeName": "Atlantic Time",
		"group": [
			"America/Puerto_Rico",
			"America/Virgin",
			"America/Anguilla",
			"America/Antigua",
			"America/Aruba",
			"America/Blanc-Sablon",
			"America/Curacao",
			"America/Dominica",
			"America/Grenada",
			"America/Guadeloupe",
			"America/Kralendijk",
			"America/Lower_Princes",
			"America/Marigot",
			"America/Montserrat",
			"America/Port_of_Spain",
			"America/St_Barthelemy",
			"America/St_Kitts",
			"America/St_Lucia",
			"America/St_Thomas",
			"America/St_Vincent",
			"America/Tortola"
		],
		"continentName": "North America",
		"countryName": "Puerto Rico",
		"mainCities": ["San Juan", "Bayamón", "Carolina", "Ponce"]
	},
	{
		"name": "America/Santo_Domingo",
		"alternativeName": "Atlantic Time",
		"group": ["America/Santo_Domingo"],
		"continentName": "North America",
		"countryName": "Dominican Republic",
		"mainCities": ["Santo Domingo", "Santiago de los Caballeros", "Santo Domingo Oeste", "Santo Domingo Este"]
	},
	{
		"name": "America/Anguilla",
		"alternativeName": "Atlantic Time",
		"group": ["America/Anguilla"],
		"continentName": "North America",
		"countryName": "Anguilla",
		"mainCities": ["The Valley"]
	},
	{
		"name": "America/Thule",
		"alternativeName": "Atlantic Time",
		"group": ["America/Thule"],
		"continentName": "North America",
		"countryName": "Greenland",
		"mainCities": ["Thule"]
	},
	{
		"name": "America/Curacao",
		"alternativeName": "Atlantic Time",
		"group": ["America/Curacao"],
		"continentName": "North America",
		"countryName": "Curacao",
		"mainCities": ["Willemstad", "Bandariba"]
	},
	{
		"name": "America/La_Paz",
		"alternativeName": "Bolivia Time",
		"group": ["America/La_Paz"],
		"continentName": "South America",
		"countryName": "Bolivia",
		"mainCities": ["La Paz", "Santa Cruz de la Sierra", "Cochabamba", "Sucre"]
	},
	{
		"name": "America/Santiago",
		"alternativeName": "Chile Time",
		"group": ["America/Santiago", "Chile/Continental"],
		"continentName": "South America",
		"countryName": "Chile",
		"mainCities": ["Santiago", "Puente Alto", "Maipú", "Antofagasta"]
	},
	{
		"name": "America/Guyana",
		"alternativeName": "Guyana Time",
		"group": ["America/Guyana"],
		"continentName": "South America",
		"countryName": "Guyana",
		"mainCities": ["Georgetown", "Linden", "New Amsterdam"]
	},
	{
		"name": "America/Caracas",
		"alternativeName": "Venezuela Time",
		"group": ["America/Caracas"],
		"continentName": "South America",
		"countryName": "Venezuela",
		"mainCities": ["Caracas", "Maracaibo", "Valencia", "Barquisimeto"]
	},
	{
		"name": "America/St_Johns",
		"alternativeName": "Newfoundland Time",
		"group": ["America/St_Johns", "Canada/Newfoundland"],
		"continentName": "North America",
		"countryName": "Canada",
		"mainCities": ["St. John's", "Mount Pearl", "Paradise", "Corner Brook"]
	},
	{
		"name": "America/Argentina/Buenos_Aires",
		"alternativeName": "Argentina Time",
		"group": [
			"America/Argentina/Buenos_Aires",
			"America/Argentina/Catamarca",
			"America/Argentina/Cordoba",
			"America/Argentina/Jujuy",
			"America/Argentina/La_Rioja",
			"America/Argentina/Mendoza",
			"America/Argentina/Rio_Gallegos",
			"America/Argentina/Salta",
			"America/Argentina/San_Juan",
			"America/Argentina/San_Luis",
			"America/Argentina/Tucuman",
			"America/Argentina/Ushuaia",
			"America/Buenos_Aires",
			"America/Catamarca",
			"America/Argentina/ComodRivadavia",
			"America/Cordoba",
			"America/Rosario",
			"America/Jujuy",
			"America/Mendoza"
		],
		"continentName": "South America",
		"countryName": "Argentina",
		"mainCities": ["Buenos Aires", "Córdoba", "Rosario", "Mar del Plata"]
	},
	{
		"name": "America/Sao_Paulo",
		"alternativeName": "Brasilia Time",
		"group": [
			"America/Araguaina",
			"America/Bahia",
			"America/Belem",
			"America/Fortaleza",
			"America/Maceio",
			"America/Recife",
			"America/Santarem",
			"America/Sao_Paulo",
			"Brazil/East"
		],
		"continentName": "South America",
		"countryName": "Brazil",
		"mainCities": ["São Paulo", "Rio de Janeiro", "Belo Horizonte", "Salvador", "Brasília"]
	},
	{
		"name": "Antarctica/Palmer",
		"alternativeName": "Chile Time",
		"group": ["Antarctica/Palmer", "Antarctica/Rothera"],
		"continentName": "Antarctica",
		"countryName": "Antarctica",
		"mainCities": ["Palmer", "Rothera"]
	},
	{
		"name": "America/Punta_Arenas",
		"alternativeName": "Chile Time",
		"group": ["America/Coyhaique", "America/Punta_Arenas"],
		"continentName": "South America",
		"countryName": "Chile",
		"mainCities": ["Punta Arenas", "Coyhaique", "Puerto Natales", "Puerto Aysén"]
	},
	{
		"name": "Atlantic/Stanley",
		"alternativeName": "Falkland Islands Time",
		"group": ["Atlantic/Stanley"],
		"continentName": "South America",
		"countryName": "Falkland Islands",
		"mainCities": ["Stanley"]
	},
	{
		"name": "America/Cayenne",
		"alternativeName": "French Guiana Time",
		"group": ["America/Cayenne"],
		"continentName": "South America",
		"countryName": "French Guiana",
		"mainCities": ["Cayenne", "Matoury", "Saint-Laurent-du-Maroni", "Kourou"]
	},
	{
		"name": "America/Asuncion",
		"alternativeName": "Paraguay Time",
		"group": ["America/Asuncion"],
		"continentName": "South America",
		"countryName": "Paraguay",
		"mainCities": ["Asunción", "Ciudad del Este", "San Lorenzo", "Capiatá"]
	},
	{
		"name": "America/Miquelon",
		"alternativeName": "St. Pierre & Miquelon Time",
		"group": ["America/Miquelon"],
		"continentName": "North America",
		"countryName": "Saint Pierre and Miquelon",
		"mainCities": ["Saint-Pierre"]
	},
	{
		"name": "America/Paramaribo",
		"alternativeName": "Suriname Time",
		"group": ["America/Paramaribo"],
		"continentName": "South America",
		"countryName": "Suriname",
		"mainCities": ["Paramaribo", "Blauwgrond", "Rainville", "Flora"]
	},
	{
		"name": "America/Montevideo",
		"alternativeName": "Uruguay Time",
		"group": ["America/Montevideo"],
		"continentName": "South America",
		"countryName": "Uruguay",
		"mainCities": ["Montevideo", "Salto", "Paysandú", "Las Piedras"]
	},
	{
		"name": "America/Noronha",
		"alternativeName": "Fernando de Noronha Time",
		"group": ["America/Noronha", "Brazil/DeNoronha"],
		"continentName": "South America",
		"countryName": "Brazil",
		"mainCities": ["Noronha"]
	},
	{
		"name": "America/Nuuk",
		"alternativeName": "Greenland Time",
		"group": ["America/Nuuk", "America/Scoresbysund", "America/Godthab"],
		"continentName": "North America",
		"countryName": "Greenland",
		"mainCities": ["Nuuk", "Scoresbysund"]
	},
	{
		"name": "Atlantic/South_Georgia",
		"alternativeName": "South Georgia Time",
		"group": ["Atlantic/South_Georgia"],
		"continentName": "Antarctica",
		"countryName": "South Georgia and the South Sandwich Islands",
		"mainCities": ["Grytviken"]
	},
	{
		"name": "Atlantic/Azores",
		"alternativeName": "Azores Time",
		"group": ["Atlantic/Azores"],
		"continentName": "Europe",
		"countryName": "Portugal",
		"mainCities": ["Ponta Delgada"]
	},
	{
		"name": "Atlantic/Cape_Verde",
		"alternativeName": "Cape Verde Time",
		"group": ["Atlantic/Cape_Verde"],
		"continentName": "Africa",
		"countryName": "Cabo Verde",
		"mainCities": ["Praia", "Mindelo", "Espargos", "Assomada"]
	},
	{
		"name": "Africa/Abidjan",
		"alternativeName": "Greenwich Mean Time",
		"group": [
			"Africa/Abidjan",
			"Iceland",
			"Africa/Accra",
			"Africa/Bamako",
			"Africa/Banjul",
			"Africa/Conakry",
			"Africa/Dakar",
			"Africa/Freetown",
			"Africa/Lome",
			"Africa/Nouakchott",
			"Africa/Ouagadougou",
			"Atlantic/Reykjavik",
			"Atlantic/St_Helena",
			"Africa/Timbuktu"
		],
		"continentName": "Africa",
		"countryName": "Ivory Coast",
		"mainCities": ["Abidjan", "Abobo", "Bouaké", "Korhogo"]
	},
	{
		"name": "Africa/Bamako",
		"alternativeName": "Greenwich Mean Time",
		"group": ["Africa/Bamako"],
		"continentName": "Africa",
		"countryName": "Mali",
		"mainCities": ["Bamako", "Sikasso", "Koutiala", "Ségou"]
	},
	{
		"name": "Africa/Bissau",
		"alternativeName": "Greenwich Mean Time",
		"group": ["Africa/Bissau"],
		"continentName": "Africa",
		"countryName": "Guinea-Bissau",
		"mainCities": ["Bissau", "Gabú", "Bafatá", "Xitole"]
	},
	{
		"name": "Africa/Conakry",
		"alternativeName": "Greenwich Mean Time",
		"group": ["Africa/Conakry"],
		"continentName": "Africa",
		"countryName": "Guinea",
		"mainCities": ["Conakry", "Camayenne", "Nzérékoré", "Kankan"]
	},
	{
		"name": "Africa/Dakar",
		"alternativeName": "Greenwich Mean Time",
		"group": ["Africa/Dakar"],
		"continentName": "Africa",
		"countryName": "Senegal",
		"mainCities": ["Dakar", "Touba", "Pikine", "Guédiawaye"]
	},
	{
		"name": "America/Danmarkshavn",
		"alternativeName": "Greenwich Mean Time",
		"group": ["America/Danmarkshavn"],
		"continentName": "North America",
		"countryName": "Greenland",
		"mainCities": ["Danmarkshavn"]
	},
	{
		"name": "Europe/Isle_of_Man",
		"alternativeName": "Greenwich Mean Time",
		"group": ["Europe/Isle_of_Man"],
		"continentName": "Europe",
		"countryName": "Isle of Man",
		"mainCities": ["Douglas"]
	},
	{
		"name": "Europe/Dublin",
		"alternativeName": "Greenwich Mean Time",
		"group": ["Europe/Dublin", "Eire"],
		"continentName": "Europe",
		"countryName": "Ireland",
		"mainCities": ["Dublin", "South Dublin", "Cork", "Limerick"]
	},
	{
		"name": "Africa/Freetown",
		"alternativeName": "Greenwich Mean Time",
		"group": ["Africa/Freetown"],
		"continentName": "Africa",
		"countryName": "Sierra Leone",
		"mainCities": ["Freetown", "Bo", "Kenema", "Koidu"]
	},
	{
		"name": "Atlantic/St_Helena",
		"alternativeName": "Greenwich Mean Time",
		"group": ["Atlantic/St_Helena"],
		"continentName": "Africa",
		"countryName": "Saint Helena",
		"mainCities": ["Jamestown"]
	},
	{
		"name": "Africa/Accra",
		"alternativeName": "Greenwich Mean Time",
		"group": ["Africa/Accra"],
		"continentName": "Africa",
		"countryName": "Ghana",
		"mainCities": ["Kumasi", "Accra", "Tamale", "Takoradi"]
	},
	{
		"name": "Africa/Lome",
		"alternativeName": "Greenwich Mean Time",
		"group": ["Africa/Lome"],
		"continentName": "Africa",
		"countryName": "Togo",
		"mainCities": ["Lomé", "Sokodé", "Kara", "Atakpamé"]
	},
	{
		"name": "Europe/London",
		"alternativeName": "Greenwich Mean Time",
		"group": ["Europe/London", "GB", "GB-Eire", "Europe/Guernsey", "Europe/Isle_of_Man", "Europe/Jersey", "Europe/Belfast"],
		"continentName": "Europe",
		"countryName": "United Kingdom",
		"mainCities": ["London", "Birmingham", "Glasgow", "Manchester"]
	},
	{
		"name": "Africa/Monrovia",
		"alternativeName": "Greenwich Mean Time",
		"group": ["Africa/Monrovia"],
		"continentName": "Africa",
		"countryName": "Liberia",
		"mainCities": ["Monrovia", "Gbarnga", "Buchanan", "Ganta"]
	},
	{
		"name": "Africa/Nouakchott",
		"alternativeName": "Greenwich Mean Time",
		"group": ["Africa/Nouakchott"],
		"continentName": "Africa",
		"countryName": "Mauritania",
		"mainCities": ["Nouakchott", "Nouadhibou", "Kiffa", "Dar Naim"]
	},
	{
		"name": "Africa/Ouagadougou",
		"alternativeName": "Greenwich Mean Time",
		"group": ["Africa/Ouagadougou"],
		"continentName": "Africa",
		"countryName": "Burkina Faso",
		"mainCities": ["Ouagadougou", "Bobo-Dioulasso", "Koudougou", "Saaba"]
	},
	{
		"name": "Atlantic/Reykjavik",
		"alternativeName": "Greenwich Mean Time",
		"group": ["Atlantic/Reykjavik"],
		"continentName": "Europe",
		"countryName": "Iceland",
		"mainCities": ["Reykjavík", "Kópavogur", "Hafnarfjörður", "Reykjanesbær"]
	},
	{
		"name": "Europe/Jersey",
		"alternativeName": "Greenwich Mean Time",
		"group": ["Europe/Jersey"],
		"continentName": "Europe",
		"countryName": "Jersey",
		"mainCities": ["Saint Helier"]
	},
	{
		"name": "Europe/Guernsey",
		"alternativeName": "Greenwich Mean Time",
		"group": ["Europe/Guernsey"],
		"continentName": "Europe",
		"countryName": "Guernsey",
		"mainCities": ["Saint Peter Port"]
	},
	{
		"name": "Africa/Banjul",
		"alternativeName": "Greenwich Mean Time",
		"group": ["Africa/Banjul"],
		"continentName": "Africa",
		"countryName": "Gambia",
		"mainCities": ["Serekunda", "Brikama", "Bununka Kunda", "Sukuta"]
	},
	{
		"name": "Africa/Sao_Tome",
		"alternativeName": "Greenwich Mean Time",
		"group": ["Africa/Sao_Tome"],
		"continentName": "Africa",
		"countryName": "Sao Tome and Principe",
		"mainCities": ["São Tomé"]
	},
	{
		"name": "Antarctica/Troll",
		"alternativeName": "Greenwich Mean Time",
		"group": ["Antarctica/Troll"],
		"continentName": "Antarctica",
		"countryName": "Antarctica",
		"mainCities": ["Troll"]
	},
	{
		"name": "Africa/Casablanca",
		"alternativeName": "Western European Time",
		"group": ["Africa/Casablanca"],
		"continentName": "Africa",
		"countryName": "Morocco",
		"mainCities": ["Casablanca", "Rabat", "Fes", "Tangier"]
	},
	{
		"name": "Africa/El_Aaiun",
		"alternativeName": "Western European Time",
		"group": ["Africa/El_Aaiun"],
		"continentName": "Africa",
		"countryName": "Western Sahara",
		"mainCities": ["Laayoune", "Dakhla", "Boujdour"]
	},
	{
		"name": "Atlantic/Canary",
		"alternativeName": "Western European Time",
		"group": ["Atlantic/Canary"],
		"continentName": "Europe",
		"countryName": "Spain",
		"mainCities": ["Las Palmas de Gran Canaria", "Santa Cruz de Tenerife", "La Laguna", "Telde"]
	},
	{
		"name": "Europe/Lisbon",
		"alternativeName": "Western European Time",
		"group": ["Atlantic/Madeira", "Europe/Lisbon", "Portugal", "WET"],
		"continentName": "Europe",
		"countryName": "Portugal",
		"mainCities": ["Lisbon", "Porto", "Amadora", "Braga"]
	},
	{
		"name": "Atlantic/Faroe",
		"alternativeName": "Western European Time",
		"group": ["Atlantic/Faroe", "Atlantic/Faeroe"],
		"continentName": "Europe",
		"countryName": "Faroe Islands",
		"mainCities": ["Tórshavn"]
	},
	{
		"name": "Africa/Windhoek",
		"alternativeName": "Central Africa Time",
		"group": ["Africa/Windhoek"],
		"continentName": "Africa",
		"countryName": "Namibia",
		"mainCities": ["Windhoek", "Rundu", "Walvis Bay", "Swakopmund"]
	},
	{
		"name": "Africa/Algiers",
		"alternativeName": "Central European Time",
		"group": ["Africa/Algiers"],
		"continentName": "Africa",
		"countryName": "Algeria",
		"mainCities": ["Algiers", "Oran", "Constantine", "Annaba"]
	},
	{
		"name": "Europe/Andorra",
		"alternativeName": "Central European Time",
		"group": ["Europe/Andorra"],
		"continentName": "Europe",
		"countryName": "Andorra",
		"mainCities": ["Andorra la Vella", "les Escaldes"]
	},
	{
		"name": "Europe/Belgrade",
		"alternativeName": "Central European Time",
		"group": ["Europe/Belgrade", "Europe/Ljubljana", "Europe/Podgorica", "Europe/Sarajevo", "Europe/Skopje", "Europe/Zagreb"],
		"continentName": "Europe",
		"countryName": "Serbia",
		"mainCities": ["Belgrade", "Niš", "Novi Sad", "Zemun"]
	},
	{
		"name": "Europe/Berlin",
		"alternativeName": "Central European Time",
		"group": [
			"Europe/Berlin",
			"Europe/Busingen",
			"Arctic/Longyearbyen",
			"Europe/Copenhagen",
			"Europe/Oslo",
			"Europe/Stockholm",
			"Atlantic/Jan_Mayen"
		],
		"continentName": "Europe",
		"countryName": "Germany",
		"mainCities": ["Berlin", "Hamburg", "Munich", "Köln"]
	},
	{
		"name": "Europe/Bratislava",
		"alternativeName": "Central European Time",
		"group": ["Europe/Bratislava"],
		"continentName": "Europe",
		"countryName": "Slovakia",
		"mainCities": ["Bratislava", "Košice", "Petržalka", "Nitra"]
	},
	{
		"name": "Europe/Brussels",
		"alternativeName": "Central European Time",
		"group": ["Europe/Brussels", "CET", "MET", "Europe/Amsterdam", "Europe/Luxembourg"],
		"continentName": "Europe",
		"countryName": "Belgium",
		"mainCities": ["Brussels", "Antwerpen", "Gent", "Charleroi"]
	},
	{
		"name": "Europe/Budapest",
		"alternativeName": "Central European Time",
		"group": ["Europe/Budapest"],
		"continentName": "Europe",
		"countryName": "Hungary",
		"mainCities": ["Budapest", "Debrecen", "Szeged", "Miskolc"]
	},
	{
		"name": "Europe/Copenhagen",
		"alternativeName": "Central European Time",
		"group": ["Europe/Copenhagen"],
		"continentName": "Europe",
		"countryName": "Denmark",
		"mainCities": ["Copenhagen", "Århus", "Odense", "Aalborg"]
	},
	{
		"name": "Europe/Gibraltar",
		"alternativeName": "Central European Time",
		"group": ["Europe/Gibraltar"],
		"continentName": "Europe",
		"countryName": "Gibraltar",
		"mainCities": ["Gibraltar"]
	},
	{
		"name": "Europe/Ljubljana",
		"alternativeName": "Central European Time",
		"group": ["Europe/Ljubljana"],
		"continentName": "Europe",
		"countryName": "Slovenia",
		"mainCities": ["Ljubljana", "Maribor", "Celje", "Kranj"]
	},
	{
		"name": "Arctic/Longyearbyen",
		"alternativeName": "Central European Time",
		"group": ["Arctic/Longyearbyen"],
		"continentName": "Europe",
		"countryName": "Svalbard and Jan Mayen",
		"mainCities": ["Longyearbyen"]
	},
	{
		"name": "Europe/Luxembourg",
		"alternativeName": "Central European Time",
		"group": ["Europe/Luxembourg"],
		"continentName": "Europe",
		"countryName": "Luxembourg",
		"mainCities": ["Luxembourg", "Esch-sur-Alzette", "Dudelange"]
	},
	{
		"name": "Europe/Madrid",
		"alternativeName": "Central European Time",
		"group": ["Africa/Ceuta", "Europe/Madrid"],
		"continentName": "Europe",
		"countryName": "Spain",
		"mainCities": ["Madrid", "Barcelona", "Valencia", "Zaragoza"]
	},
	{
		"name": "Europe/Monaco",
		"alternativeName": "Central European Time",
		"group": ["Europe/Monaco"],
		"continentName": "Europe",
		"countryName": "Monaco",
		"mainCities": ["Monaco", "Monte-Carlo"]
	},
	{
		"name": "Europe/Oslo",
		"alternativeName": "Central European Time",
		"group": ["Europe/Oslo"],
		"continentName": "Europe",
		"countryName": "Norway",
		"mainCities": ["Oslo", "Bergen", "Trondheim", "Stavanger"]
	},
	{
		"name": "Europe/Paris",
		"alternativeName": "Central European Time",
		"group": ["Europe/Paris", "Europe/Monaco"],
		"continentName": "Europe",
		"countryName": "France",
		"mainCities": ["Paris", "Marseille", "Lyon", "Toulouse"]
	},
	{
		"name": "Europe/Podgorica",
		"alternativeName": "Central European Time",
		"group": ["Europe/Podgorica"],
		"continentName": "Europe",
		"countryName": "Montenegro",
		"mainCities": ["Podgorica", "Nikšić", "Herceg Novi", "Pljevlja"]
	},
	{
		"name": "Europe/Prague",
		"alternativeName": "Central European Time",
		"group": ["Europe/Prague", "Europe/Bratislava"],
		"continentName": "Europe",
		"countryName": "Czechia",
		"mainCities": ["Prague", "Brno", "Ostrava", "Pilsen"]
	},
	{
		"name": "Europe/Rome",
		"alternativeName": "Central European Time",
		"group": ["Europe/Rome", "Europe/San_Marino", "Europe/Vatican"],
		"continentName": "Europe",
		"countryName": "Italy",
		"mainCities": ["Rome", "Milan", "Naples", "Turin"]
	},
	{
		"name": "Europe/Amsterdam",
		"alternativeName": "Central European Time",
		"group": ["Europe/Amsterdam"],
		"continentName": "Europe",
		"countryName": "The Netherlands",
		"mainCities": ["Rotterdam", "Amsterdam", "The Hague", "Utrecht"]
	},
	{
		"name": "Europe/San_Marino",
		"alternativeName": "Central European Time",
		"group": ["Europe/San_Marino"],
		"continentName": "Europe",
		"countryName": "San Marino",
		"mainCities": ["San Marino"]
	},
	{
		"name": "Europe/Malta",
		"alternativeName": "Central European Time",
		"group": ["Europe/Malta"],
		"continentName": "Europe",
		"countryName": "Malta",
		"mainCities": ["San Pawl il-Baħar", "Birkirkara", "Mosta", "Sliema"]
	},
	{
		"name": "Europe/Sarajevo",
		"alternativeName": "Central European Time",
		"group": ["Europe/Sarajevo"],
		"continentName": "Europe",
		"countryName": "Bosnia and Herzegovina",
		"mainCities": ["Sarajevo", "Banja Luka", "Zenica", "Tuzla"]
	},
	{
		"name": "Europe/Skopje",
		"alternativeName": "Central European Time",
		"group": ["Europe/Skopje"],
		"continentName": "Europe",
		"countryName": "North Macedonia",
		"mainCities": ["Skopje", "Kumanovo", "Prilep", "Bitola"]
	},
	{
		"name": "Europe/Stockholm",
		"alternativeName": "Central European Time",
		"group": ["Europe/Stockholm"],
		"continentName": "Europe",
		"countryName": "Sweden",
		"mainCities": ["Stockholm", "Göteborg", "Malmö", "Uppsala"]
	},
	{
		"name": "Europe/Tirane",
		"alternativeName": "Central European Time",
		"group": ["Europe/Tirane"],
		"continentName": "Europe",
		"countryName": "Albania",
		"mainCities": ["Tirana", "Durrës", "Vlorë", "Elbasan"]
	},
	{
		"name": "Africa/Tunis",
		"alternativeName": "Central European Time",
		"group": ["Africa/Tunis"],
		"continentName": "Africa",
		"countryName": "Tunisia",
		"mainCities": ["Tunis", "Sfax", "Sousse", "Kairouan"]
	},
	{
		"name": "Europe/Vaduz",
		"alternativeName": "Central European Time",
		"group": ["Europe/Vaduz"],
		"continentName": "Europe",
		"countryName": "Liechtenstein",
		"mainCities": ["Vaduz"]
	},
	{
		"name": "Europe/Vatican",
		"alternativeName": "Central European Time",
		"group": ["Europe/Vatican"],
		"continentName": "Europe",
		"countryName": "Vatican",
		"mainCities": ["Vatican City"]
	},
	{
		"name": "Europe/Vienna",
		"alternativeName": "Central European Time",
		"group": ["Europe/Vienna"],
		"continentName": "Europe",
		"countryName": "Austria",
		"mainCities": ["Vienna", "Graz", "Linz", "Favoriten"]
	},
	{
		"name": "Europe/Warsaw",
		"alternativeName": "Central European Time",
		"group": ["Europe/Warsaw", "Poland"],
		"continentName": "Europe",
		"countryName": "Poland",
		"mainCities": ["Warsaw", "Łódź", "Kraków", "Wrocław"]
	},
	{
		"name": "Europe/Zagreb",
		"alternativeName": "Central European Time",
		"group": ["Europe/Zagreb"],
		"continentName": "Europe",
		"countryName": "Croatia",
		"mainCities": ["Zagreb", "Split", "Rijeka", "Osijek"]
	},
	{
		"name": "Europe/Zurich",
		"alternativeName": "Central European Time",
		"group": ["Europe/Zurich", "Europe/Busingen", "Europe/Vaduz"],
		"continentName": "Europe",
		"countryName": "Switzerland",
		"mainCities": ["Zürich", "Genève", "Basel", "Lausanne"]
	},
	{
		"name": "Africa/Bangui",
		"alternativeName": "West Africa Time",
		"group": ["Africa/Bangui"],
		"continentName": "Africa",
		"countryName": "Central African Republic",
		"mainCities": ["Bangui", "Bimbo", "Bégoua", "Carnot"]
	},
	{
		"name": "Africa/Malabo",
		"alternativeName": "West Africa Time",
		"group": ["Africa/Malabo"],
		"continentName": "Africa",
		"countryName": "Equatorial Guinea",
		"mainCities": ["Bata", "Malabo", "Ebebiyin"]
	},
	{
		"name": "Africa/Brazzaville",
		"alternativeName": "West Africa Time",
		"group": ["Africa/Brazzaville"],
		"continentName": "Africa",
		"countryName": "Republic of the Congo",
		"mainCities": ["Brazzaville", "Pointe-Noire", "Dolisie", "Nkayi"]
	},
	{
		"name": "Africa/Porto-Novo",
		"alternativeName": "West Africa Time",
		"group": ["Africa/Porto-Novo"],
		"continentName": "Africa",
		"countryName": "Benin",
		"mainCities": ["Cotonou", "Abomey-Calavi", "Porto-Novo", "Parakou"]
	},
	{
		"name": "Africa/Douala",
		"alternativeName": "West Africa Time",
		"group": ["Africa/Douala"],
		"continentName": "Africa",
		"countryName": "Cameroon",
		"mainCities": ["Douala", "Yaoundé", "Bamenda", "Bafoussam"]
	},
	{
		"name": "Africa/Kinshasa",
		"alternativeName": "West Africa Time",
		"group": ["Africa/Kinshasa"],
		"continentName": "Africa",
		"countryName": "Democratic Republic of the Congo",
		"mainCities": ["Kinshasa", "Kikwit", "Masina", "Mbandaka"]
	},
	{
		"name": "Africa/Lagos",
		"alternativeName": "West Africa Time",
		"group": [
			"Africa/Lagos",
			"Africa/Bangui",
			"Africa/Brazzaville",
			"Africa/Douala",
			"Africa/Kinshasa",
			"Africa/Libreville",
			"Africa/Luanda",
			"Africa/Malabo",
			"Africa/Niamey",
			"Africa/Porto-Novo"
		],
		"continentName": "Africa",
		"countryName": "Nigeria",
		"mainCities": ["Lagos", "Kano", "Ibadan", "Abuja"]
	},
	{
		"name": "Africa/Libreville",
		"alternativeName": "West Africa Time",
		"group": ["Africa/Libreville"],
		"continentName": "Africa",
		"countryName": "Gabon",
		"mainCities": ["Libreville", "Port-Gentil", "Franceville", "Owendo"]
	},
	{
		"name": "Africa/Luanda",
		"alternativeName": "West Africa Time",
		"group": ["Africa/Luanda"],
		"continentName": "Africa",
		"countryName": "Angola",
		"mainCities": ["Luanda", "Lubango", "Huambo", "Benguela"]
	},
	{
		"name": "Africa/Ndjamena",
		"alternativeName": "West Africa Time",
		"group": ["Africa/Ndjamena"],
		"continentName": "Africa",
		"countryName": "Chad",
		"mainCities": ["N'Djamena", "Moundou", "Abéché", "Sarh"]
	},
	{
		"name": "Africa/Niamey",
		"alternativeName": "West Africa Time",
		"group": ["Africa/Niamey"],
		"continentName": "Africa",
		"countryName": "Niger",
		"mainCities": ["Niamey", "Maradi", "Zinder", "Tahoua"]
	},
	{
		"name": "Africa/Bujumbura",
		"alternativeName": "Central Africa Time",
		"group": ["Africa/Bujumbura"],
		"continentName": "Africa",
		"countryName": "Burundi",
		"mainCities": ["Bujumbura", "Gitega", "Ngozi", "Rumonge"]
	},
	{
		"name": "Africa/Gaborone",
		"alternativeName": "Central Africa Time",
		"group": ["Africa/Gaborone"],
		"continentName": "Africa",
		"countryName": "Botswana",
		"mainCities": ["Gaborone", "Francistown", "Mogoditshane", "Maun"]
	},
	{
		"name": "Africa/Harare",
		"alternativeName": "Central Africa Time",
		"group": ["Africa/Harare"],
		"continentName": "Africa",
		"countryName": "Zimbabwe",
		"mainCities": ["Harare", "Bulawayo", "Chitungwiza", "Mutare"]
	},
	{
		"name": "Africa/Juba",
		"alternativeName": "Central Africa Time",
		"group": ["Africa/Juba"],
		"continentName": "Africa",
		"countryName": "South Sudan",
		"mainCities": ["Juba", "Winejok", "Yei", "Malakal"]
	},
	{
		"name": "Africa/Khartoum",
		"alternativeName": "Central Africa Time",
		"group": ["Africa/Khartoum"],
		"continentName": "Africa",
		"countryName": "Sudan",
		"mainCities": ["Khartoum", "Omdurman", "Khartoum North", "Nyala"]
	},
	{
		"name": "Africa/Kigali",
		"alternativeName": "Central Africa Time",
		"group": ["Africa/Kigali"],
		"continentName": "Africa",
		"countryName": "Rwanda",
		"mainCities": ["Kigali", "Gisenyi", "Musanze", "Nyagatare"]
	},
	{
		"name": "Africa/Blantyre",
		"alternativeName": "Central Africa Time",
		"group": ["Africa/Blantyre"],
		"continentName": "Africa",
		"countryName": "Malawi",
		"mainCities": ["Lilongwe", "Blantyre", "Mzuzu", "Zomba"]
	},
	{
		"name": "Africa/Lubumbashi",
		"alternativeName": "Central Africa Time",
		"group": ["Africa/Lubumbashi"],
		"continentName": "Africa",
		"countryName": "Democratic Republic of the Congo",
		"mainCities": ["Lubumbashi", "Mbuji-Mayi", "Kananga", "Kisangani"]
	},
	{
		"name": "Africa/Lusaka",
		"alternativeName": "Central Africa Time",
		"group": ["Africa/Lusaka"],
		"continentName": "Africa",
		"countryName": "Zambia",
		"mainCities": ["Lusaka", "Kitwe", "Ndola", "Chipata"]
	},
	{
		"name": "Africa/Maputo",
		"alternativeName": "Central Africa Time",
		"group": [
			"Africa/Maputo",
			"Africa/Blantyre",
			"Africa/Bujumbura",
			"Africa/Gaborone",
			"Africa/Harare",
			"Africa/Kigali",
			"Africa/Lubumbashi",
			"Africa/Lusaka"
		],
		"continentName": "Africa",
		"countryName": "Mozambique",
		"mainCities": ["Maputo", "Matola", "Nampula", "Beira"]
	},
	{
		"name": "Europe/Athens",
		"alternativeName": "Eastern European Time",
		"group": ["Europe/Athens", "EET"],
		"continentName": "Europe",
		"countryName": "Greece",
		"mainCities": ["Athens", "Thessaloníki", "Pátra", "Piraeus"]
	},
	{
		"name": "Asia/Beirut",
		"alternativeName": "Eastern European Time",
		"group": ["Asia/Beirut"],
		"continentName": "Asia",
		"countryName": "Lebanon",
		"mainCities": ["Beirut", "Ra’s Bayrūt", "Tripoli", "Sidon"]
	},
	{
		"name": "Europe/Bucharest",
		"alternativeName": "Eastern European Time",
		"group": ["Europe/Bucharest"],
		"continentName": "Europe",
		"countryName": "Romania",
		"mainCities": ["Bucharest", "Sector 3", "Iaşi", "Sector 6"]
	},
	{
		"name": "Africa/Cairo",
		"alternativeName": "Eastern European Time",
		"group": ["Africa/Cairo", "Egypt"],
		"continentName": "Africa",
		"countryName": "Egypt",
		"mainCities": ["Cairo", "Alexandria", "Giza", "Shubrā al Khaymah"]
	},
	{
		"name": "Europe/Chisinau",
		"alternativeName": "Eastern European Time",
		"group": ["Europe/Chisinau", "Europe/Tiraspol"],
		"continentName": "Europe",
		"countryName": "Moldova",
		"mainCities": ["Chisinau", "Tiraspol", "Bălţi", "Bender"]
	},
	{
		"name": "Asia/Hebron",
		"alternativeName": "Eastern European Time",
		"group": ["Asia/Gaza", "Asia/Hebron"],
		"continentName": "Asia",
		"countryName": "Palestinian Territory",
		"mainCities": ["East Jerusalem", "Gaza", "Khān Yūnis", "Jabālyā"]
	},
	{
		"name": "Europe/Helsinki",
		"alternativeName": "Eastern European Time",
		"group": ["Europe/Helsinki", "Europe/Mariehamn"],
		"continentName": "Europe",
		"countryName": "Finland",
		"mainCities": ["Helsinki", "Espoo", "Tampere", "Vantaa"]
	},
	{
		"name": "Europe/Kaliningrad",
		"alternativeName": "Eastern European Time",
		"group": ["Europe/Kaliningrad"],
		"continentName": "Europe",
		"countryName": "Russia",
		"mainCities": ["Kaliningrad", "Chernyakhovsk", "Sovetsk", "Baltiysk"]
	},
	{
		"name": "Europe/Kyiv",
		"alternativeName": "Eastern European Time",
		"group": ["Europe/Kyiv", "Europe/Uzhgorod", "Europe/Zaporozhye", "Europe/Kiev"],
		"continentName": "Europe",
		"countryName": "Ukraine",
		"mainCities": ["Kyiv", "Kharkiv", "Odesa", "Dnipro"]
	},
	{
		"name": "Europe/Mariehamn",
		"alternativeName": "Eastern European Time",
		"group": ["Europe/Mariehamn"],
		"continentName": "Europe",
		"countryName": "Aland Islands",
		"mainCities": ["Mariehamn"]
	},
	{
		"name": "Asia/Nicosia",
		"alternativeName": "Eastern European Time",
		"group": ["Asia/Famagusta", "Asia/Nicosia", "Europe/Nicosia"],
		"continentName": "Europe",
		"countryName": "Cyprus",
		"mainCities": ["Nicosia", "Limassol", "Larnaca", "Stróvolos"]
	},
	{
		"name": "Europe/Riga",
		"alternativeName": "Eastern European Time",
		"group": ["Europe/Riga"],
		"continentName": "Europe",
		"countryName": "Latvia",
		"mainCities": ["Riga", "Daugavpils", "Liepāja", "Jelgava"]
	},
	{
		"name": "Europe/Sofia",
		"alternativeName": "Eastern European Time",
		"group": ["Europe/Sofia"],
		"continentName": "Europe",
		"countryName": "Bulgaria",
		"mainCities": ["Sofia", "Plovdiv", "Varna", "Burgas"]
	},
	{
		"name": "Europe/Tallinn",
		"alternativeName": "Eastern European Time",
		"group": ["Europe/Tallinn"],
		"continentName": "Europe",
		"countryName": "Estonia",
		"mainCities": ["Tallinn", "Tartu", "Narva", "Pärnu"]
	},
	{
		"name": "Africa/Tripoli",
		"alternativeName": "Eastern European Time",
		"group": ["Africa/Tripoli", "Libya"],
		"continentName": "Africa",
		"countryName": "Libya",
		"mainCities": ["Tripoli", "Benghazi", "Misratah", "Zliten"]
	},
	{
		"name": "Europe/Vilnius",
		"alternativeName": "Eastern European Time",
		"group": ["Europe/Vilnius"],
		"continentName": "Europe",
		"countryName": "Lithuania",
		"mainCities": ["Vilnius", "Kaunas", "Klaipėda", "Šiauliai"]
	},
	{
		"name": "Asia/Jerusalem",
		"alternativeName": "Israel Time",
		"group": ["Asia/Jerusalem", "Israel", "Asia/Tel_Aviv"],
		"continentName": "Asia",
		"countryName": "Israel",
		"mainCities": ["Jerusalem", "Tel Aviv", "West Jerusalem", "Haifa"]
	},
	{
		"name": "Africa/Johannesburg",
		"alternativeName": "South Africa Time",
		"group": ["Africa/Johannesburg", "Africa/Maseru", "Africa/Mbabane"],
		"continentName": "Africa",
		"countryName": "South Africa",
		"mainCities": ["Johannesburg", "Cape Town", "Durban", "Pretoria"]
	},
	{
		"name": "Africa/Mbabane",
		"alternativeName": "South Africa Time",
		"group": ["Africa/Mbabane"],
		"continentName": "Africa",
		"countryName": "Eswatini",
		"mainCities": ["Manzini", "Mbabane", "Lobamba"]
	},
	{
		"name": "Africa/Maseru",
		"alternativeName": "South Africa Time",
		"group": ["Africa/Maseru"],
		"continentName": "Africa",
		"countryName": "Lesotho",
		"mainCities": ["Maseru", "Maputsoe", "Mohale's Hoek", "Mafeteng"]
	},
	{
		"name": "Asia/Kuwait",
		"alternativeName": "Arabian Time",
		"group": ["Asia/Kuwait"],
		"continentName": "Asia",
		"countryName": "Kuwait",
		"mainCities": ["Al Aḩmadī", "Ḩawallī", "As Sālimīyah", "Şabāḩ as Sālim"]
	},
	{
		"name": "Asia/Bahrain",
		"alternativeName": "Arabian Time",
		"group": ["Asia/Bahrain"],
		"continentName": "Asia",
		"countryName": "Bahrain",
		"mainCities": ["Al Muharraq", "Manama", "Madīnat Ḩamad", "Ar Rifā‘"]
	},
	{
		"name": "Asia/Baghdad",
		"alternativeName": "Arabian Time",
		"group": ["Asia/Baghdad"],
		"continentName": "Asia",
		"countryName": "Iraq",
		"mainCities": ["Baghdad", "Al Mawşil al Jadīdah", "Al Başrah al Qadīmah", "Mosul"]
	},
	{
		"name": "Asia/Qatar",
		"alternativeName": "Arabian Time",
		"group": ["Asia/Qatar", "Asia/Bahrain"],
		"continentName": "Asia",
		"countryName": "Qatar",
		"mainCities": ["Doha", "Ar Rayyān", "Al Maţār al ‘Atīq", "Al Manşūrah"]
	},
	{
		"name": "Asia/Riyadh",
		"alternativeName": "Arabian Time",
		"group": ["Asia/Riyadh", "Antarctica/Syowa", "Asia/Aden", "Asia/Kuwait"],
		"continentName": "Asia",
		"countryName": "Saudi Arabia",
		"mainCities": ["Jeddah", "Riyadh", "Makkah", "Madinah"]
	},
	{
		"name": "Asia/Aden",
		"alternativeName": "Arabian Time",
		"group": ["Asia/Aden"],
		"continentName": "Asia",
		"countryName": "Yemen",
		"mainCities": ["Sanaa", "Aden", "Taiz", "Ibb"]
	},
	{
		"name": "Asia/Amman",
		"alternativeName": "Asia/Amman",
		"group": ["Asia/Amman"],
		"continentName": "Asia",
		"countryName": "Jordan",
		"mainCities": ["Amman", "Zarqa", "Irbid", "Russeifa"]
	},
	{
		"name": "Asia/Damascus",
		"alternativeName": "Asia/Damascus",
		"group": ["Asia/Damascus"],
		"continentName": "Asia",
		"countryName": "Syria",
		"mainCities": ["Aleppo", "Damascus", "Homs", "Latakia"]
	},
	{
		"name": "Africa/Addis_Ababa",
		"alternativeName": "East Africa Time",
		"group": ["Africa/Addis_Ababa"],
		"continentName": "Africa",
		"countryName": "Ethiopia",
		"mainCities": ["Addis Ababa", "Jijiga", "Gonder", "Mek'ele"]
	},
	{
		"name": "Indian/Antananarivo",
		"alternativeName": "East Africa Time",
		"group": ["Indian/Antananarivo"],
		"continentName": "Africa",
		"countryName": "Madagascar",
		"mainCities": ["Antananarivo", "Toamasina", "Antsirabe", "Mahajanga"]
	},
	{
		"name": "Africa/Asmara",
		"alternativeName": "East Africa Time",
		"group": ["Africa/Asmara"],
		"continentName": "Africa",
		"countryName": "Eritrea",
		"mainCities": ["Asmara", "Keren", "Himora", "Massawa"]
	},
	{
		"name": "Africa/Dar_es_Salaam",
		"alternativeName": "East Africa Time",
		"group": ["Africa/Dar_es_Salaam"],
		"continentName": "Africa",
		"countryName": "Tanzania",
		"mainCities": ["Dar es Salaam", "Mwanza", "Dodoma", "Zanzibar"]
	},
	{
		"name": "Africa/Djibouti",
		"alternativeName": "East Africa Time",
		"group": ["Africa/Djibouti"],
		"continentName": "Africa",
		"countryName": "Djibouti",
		"mainCities": ["Djibouti", "Ali Sabih", "Dikhil", "Tadjoura"]
	},
	{
		"name": "Africa/Kampala",
		"alternativeName": "East Africa Time",
		"group": ["Africa/Kampala"],
		"continentName": "Africa",
		"countryName": "Uganda",
		"mainCities": ["Kampala", "Nansana", "Kira", "Bunamwaya"]
	},
	{
		"name": "Indian/Mayotte",
		"alternativeName": "East Africa Time",
		"group": ["Indian/Mayotte"],
		"continentName": "Africa",
		"countryName": "Mayotte",
		"mainCities": ["Mamoudzou", "Koungou", "Labattoir", "Kaouéni"]
	},
	{
		"name": "Africa/Mogadishu",
		"alternativeName": "East Africa Time",
		"group": ["Africa/Mogadishu"],
		"continentName": "Africa",
		"countryName": "Somalia",
		"mainCities": ["Mogadishu", "Borama", "Hargeysa", "Berbera"]
	},
	{
		"name": "Indian/Comoro",
		"alternativeName": "East Africa Time",
		"group": ["Indian/Comoro"],
		"continentName": "Africa",
		"countryName": "Comoros",
		"mainCities": ["Moroni", "Moutsamoudou", "Fomboni"]
	},
	{
		"name": "Africa/Nairobi",
		"alternativeName": "East Africa Time",
		"group": [
			"Africa/Nairobi",
			"Africa/Addis_Ababa",
			"Africa/Asmara",
			"Africa/Dar_es_Salaam",
			"Africa/Djibouti",
			"Africa/Kampala",
			"Africa/Mogadishu",
			"Indian/Antananarivo",
			"Indian/Comoro",
			"Indian/Mayotte",
			"Africa/Asmera"
		],
		"continentName": "Africa",
		"countryName": "Kenya",
		"mainCities": ["Nairobi", "Kakamega", "Mombasa", "Nakuru"]
	},
	{
		"name": "Europe/Minsk",
		"alternativeName": "Moscow Time",
		"group": ["Europe/Minsk"],
		"continentName": "Europe",
		"countryName": "Belarus",
		"mainCities": ["Minsk", "Homyel'", "Hrodna", "Vitebsk"]
	},
	{
		"name": "Europe/Moscow",
		"alternativeName": "Moscow Time",
		"group": ["Europe/Kirov", "Europe/Moscow", "Europe/Volgograd", "W-SU"],
		"continentName": "Europe",
		"countryName": "Russia",
		"mainCities": ["Moscow", "Saint Petersburg", "Nizhniy Novgorod", "Kazan"]
	},
	{
		"name": "Europe/Simferopol",
		"alternativeName": "Moscow Time",
		"group": ["Europe/Simferopol"],
		"continentName": "Europe",
		"countryName": "Ukraine",
		"mainCities": ["Sevastopol", "Simferopol", "Kerch", "Yevpatoriya"]
	},
	{
		"name": "Antarctica/Syowa",
		"alternativeName": "Syowa Time",
		"group": ["Antarctica/Syowa"],
		"continentName": "Antarctica",
		"countryName": "Antarctica",
		"mainCities": ["Syowa"]
	},
	{
		"name": "Europe/Istanbul",
		"alternativeName": "Turkey Time",
		"group": ["Europe/Istanbul", "Turkey", "Asia/Istanbul"],
		"continentName": "Asia",
		"countryName": "Turkey",
		"mainCities": ["Istanbul", "Ankara", "Bursa", "İzmir"]
	},
	{
		"name": "Asia/Tehran",
		"alternativeName": "Iran Time",
		"group": ["Asia/Tehran", "Iran"],
		"continentName": "Asia",
		"countryName": "Iran",
		"mainCities": ["Tehran", "Mashhad", "Isfahan", "Karaj"]
	},
	{
		"name": "Asia/Yerevan",
		"alternativeName": "Armenia Time",
		"group": ["Asia/Yerevan"],
		"continentName": "Asia",
		"countryName": "Armenia",
		"mainCities": ["Yerevan", "Malatia-Sebastia", "Shengavit", "Nor Nork"]
	},
	{
		"name": "Asia/Baku",
		"alternativeName": "Azerbaijan Time",
		"group": ["Asia/Baku"],
		"continentName": "Asia",
		"countryName": "Azerbaijan",
		"mainCities": ["Baku", "Sumqayıt", "Ganja", "Lankaran"]
	},
	{
		"name": "Asia/Tbilisi",
		"alternativeName": "Georgia Time",
		"group": ["Asia/Tbilisi"],
		"continentName": "Asia",
		"countryName": "Georgia",
		"mainCities": ["Tbilisi", "Batumi", "Kutaisi", "Rustavi"]
	},
	{
		"name": "Asia/Dubai",
		"alternativeName": "Gulf Time",
		"group": ["Asia/Dubai", "Asia/Muscat", "Indian/Mahe", "Indian/Reunion"],
		"continentName": "Asia",
		"countryName": "United Arab Emirates",
		"mainCities": ["Dubai", "Abu Dhabi", "Sharjah", "Al Ain City"]
	},
	{
		"name": "Asia/Muscat",
		"alternativeName": "Gulf Time",
		"group": ["Asia/Muscat"],
		"continentName": "Asia",
		"countryName": "Oman",
		"mainCities": ["Muscat", "Seeb", "Bawshar", "‘Ibrī"]
	},
	{
		"name": "Indian/Mauritius",
		"alternativeName": "Mauritius Time",
		"group": ["Indian/Mauritius"],
		"continentName": "Africa",
		"countryName": "Mauritius",
		"mainCities": ["Port Louis", "Vacoas", "Beau Bassin-Rose Hill", "Curepipe"]
	},
	{
		"name": "Indian/Reunion",
		"alternativeName": "Réunion Time",
		"group": ["Indian/Reunion"],
		"continentName": "Africa",
		"countryName": "Reunion",
		"mainCities": ["Saint-Denis", "Saint-Paul", "Saint-Pierre", "Le Tampon"]
	},
	{
		"name": "Europe/Samara",
		"alternativeName": "Samara Time",
		"group": ["Europe/Astrakhan", "Europe/Samara", "Europe/Saratov", "Europe/Ulyanovsk"],
		"continentName": "Europe",
		"countryName": "Russia",
		"mainCities": ["Samara", "Saratov", "Tolyatti", "Izhevsk"]
	},
	{
		"name": "Indian/Mahe",
		"alternativeName": "Seychelles Time",
		"group": ["Indian/Mahe"],
		"continentName": "Africa",
		"countryName": "Seychelles",
		"mainCities": ["Victoria"]
	},
	{
		"name": "Asia/Kabul",
		"alternativeName": "Afghanistan Time",
		"group": ["Asia/Kabul"],
		"continentName": "Asia",
		"countryName": "Afghanistan",
		"mainCities": ["Kabul", "Herāt", "Mazār-e Sharīf", "Kandahār"]
	},
	{
		"name": "Indian/Kerguelen",
		"alternativeName": "French Southern & Antarctic Time",
		"group": ["Indian/Kerguelen"],
		"continentName": "Antarctica",
		"countryName": "French Southern Territories",
		"mainCities": ["Port-aux-Français"]
	},
	{
		"name": "Asia/Almaty",
		"alternativeName": "Kazakhstan Time",
		"group": ["Asia/Almaty", "Asia/Aqtau", "Asia/Aqtobe", "Asia/Atyrau", "Asia/Oral", "Asia/Qostanay", "Asia/Qyzylorda"],
		"continentName": "Asia",
		"countryName": "Kazakhstan",
		"mainCities": ["Almaty", "Shymkent", "Aktobe", "Karagandy", "Astana"]
	},
	{
		"name": "Indian/Maldives",
		"alternativeName": "Maldives Time",
		"group": ["Indian/Maldives", "Indian/Kerguelen"],
		"continentName": "Asia",
		"countryName": "Maldives",
		"mainCities": ["Male"]
	},
	{
		"name": "Antarctica/Mawson",
		"alternativeName": "Mawson Time",
		"group": ["Antarctica/Mawson", "Antarctica/Vostok"],
		"continentName": "Antarctica",
		"countryName": "Antarctica",
		"mainCities": ["Mawson", "Vostok"]
	},
	{
		"name": "Asia/Karachi",
		"alternativeName": "Pakistan Time",
		"group": ["Asia/Karachi"],
		"continentName": "Asia",
		"countryName": "Pakistan",
		"mainCities": ["Lahore", "Karachi", "Peshawar", "Faisalabad", "Islamabad"]
	},
	{
		"name": "Asia/Dushanbe",
		"alternativeName": "Tajikistan Time",
		"group": ["Asia/Dushanbe"],
		"continentName": "Asia",
		"countryName": "Tajikistan",
		"mainCities": ["Dushanbe", "Isfara", "Istaravshan", "Kŭlob"]
	},
	{
		"name": "Asia/Ashgabat",
		"alternativeName": "Turkmenistan Time",
		"group": ["Asia/Ashgabat", "Asia/Ashkhabad"],
		"continentName": "Asia",
		"countryName": "Turkmenistan",
		"mainCities": ["Ashgabat", "Türkmenabat", "Daşoguz", "Mary"]
	},
	{
		"name": "Asia/Tashkent",
		"alternativeName": "Uzbekistan Time",
		"group": ["Asia/Samarkand", "Asia/Tashkent"],
		"continentName": "Asia",
		"countryName": "Uzbekistan",
		"mainCities": ["Tashkent", "Andijon", "Namangan", "Samarkand"]
	},
	{
		"name": "Asia/Yekaterinburg",
		"alternativeName": "Yekaterinburg Time",
		"group": ["Asia/Yekaterinburg"],
		"continentName": "Europe",
		"countryName": "Russia",
		"mainCities": ["Yekaterinburg", "Chelyabinsk", "Ufa", "Perm"]
	},
	{
		"name": "Asia/Colombo",
		"alternativeName": "India Time",
		"group": ["Asia/Colombo"],
		"continentName": "Asia",
		"countryName": "Sri Lanka",
		"mainCities": ["Colombo", "Dehiwala-Mount Lavinia", "Maharagama", "Jaffna"]
	},
	{
		"name": "Asia/Kolkata",
		"alternativeName": "India Time",
		"group": ["Asia/Kolkata", "Asia/Calcutta"],
		"continentName": "Asia",
		"countryName": "India",
		"mainCities": ["Mumbai", "Delhi", "Bengaluru", "Hyderabad", "New Delhi"]
	},
	{
		"name": "Asia/Kathmandu",
		"alternativeName": "Nepal Time",
		"group": ["Asia/Kathmandu", "Asia/Katmandu"],
		"continentName": "Asia",
		"countryName": "Nepal",
		"mainCities": ["Kathmandu", "Pokhara", "Bharatpur", "Pātan"]
	},
	{
		"name": "Asia/Dhaka",
		"alternativeName": "Bangladesh Time",
		"group": ["Asia/Dhaka", "Asia/Dacca"],
		"continentName": "Asia",
		"countryName": "Bangladesh",
		"mainCities": ["Dhaka", "Chattogram", "Gazipur", "Khulna"]
	},
	{
		"name": "Asia/Thimphu",
		"alternativeName": "Bhutan Time",
		"group": ["Asia/Thimphu", "Asia/Thimbu"],
		"continentName": "Asia",
		"countryName": "Bhutan",
		"mainCities": ["Thimphu", "Phuntsholing", "Tsirang", "Punākha"]
	},
	{
		"name": "Asia/Urumqi",
		"alternativeName": "China Time",
		"group": ["Asia/Urumqi", "Asia/Kashgar"],
		"continentName": "Asia",
		"countryName": "China",
		"mainCities": ["Ürümqi", "Shihezi", "Korla", "Aqsu"]
	},
	{
		"name": "Indian/Chagos",
		"alternativeName": "Indian Ocean Time",
		"group": ["Indian/Chagos"],
		"continentName": "Asia",
		"countryName": "British Indian Ocean Territory",
		"mainCities": ["Chagos"]
	},
	{
		"name": "Asia/Bishkek",
		"alternativeName": "Kyrgyzstan Time",
		"group": ["Asia/Bishkek"],
		"continentName": "Asia",
		"countryName": "Kyrgyzstan",
		"mainCities": ["Bishkek", "Osh", "Jalal-Abad", "Karakol"]
	},
	{
		"name": "Asia/Omsk",
		"alternativeName": "Omsk Time",
		"group": ["Asia/Omsk"],
		"continentName": "Europe",
		"countryName": "Russia",
		"mainCities": ["Omsk", "Tara", "Kalachinsk", "Isil’kul’"]
	},
	{
		"name": "Indian/Cocos",
		"alternativeName": "Cocos Islands Time",
		"group": ["Indian/Cocos"],
		"continentName": "Asia",
		"countryName": "Cocos Islands",
		"mainCities": ["West Island"]
	},
	{
		"name": "Asia/Yangon",
		"alternativeName": "Myanmar Time",
		"group": ["Asia/Yangon", "Indian/Cocos", "Asia/Rangoon"],
		"continentName": "Asia",
		"countryName": "Myanmar",
		"mainCities": ["Yangon", "Mandalay", "Nay Pyi Taw", "Hlaingthaya Township", "Naypyidaw"]
	},
	{
		"name": "Indian/Christmas",
		"alternativeName": "Christmas Island Time",
		"group": ["Indian/Christmas"],
		"continentName": "Oceania",
		"countryName": "Christmas Island",
		"mainCities": ["Flying Fish Cove"]
	},
	{
		"name": "Antarctica/Davis",
		"alternativeName": "Davis Time",
		"group": ["Antarctica/Davis"],
		"continentName": "Antarctica",
		"countryName": "Antarctica",
		"mainCities": ["Davis"]
	},
	{
		"name": "Asia/Hovd",
		"alternativeName": "Hovd Time",
		"group": ["Asia/Hovd"],
		"continentName": "Asia",
		"countryName": "Mongolia",
		"mainCities": ["Ulaangom", "Khovd", "Ölgii", "Altai"]
	},
	{
		"name": "Asia/Bangkok",
		"alternativeName": "Indochina Time",
		"group": ["Asia/Bangkok", "Asia/Phnom_Penh", "Asia/Vientiane", "Indian/Christmas"],
		"continentName": "Asia",
		"countryName": "Thailand",
		"mainCities": ["Bangkok", "Samut Prakan", "Mueang Nonthaburi", "Chon Buri"]
	},
	{
		"name": "Asia/Ho_Chi_Minh",
		"alternativeName": "Indochina Time",
		"group": ["Asia/Ho_Chi_Minh", "Asia/Saigon"],
		"continentName": "Asia",
		"countryName": "Vietnam",
		"mainCities": ["Ho Chi Minh City", "Cần Thơ", "Da Nang", "Biên Hòa"]
	},
	{
		"name": "Asia/Phnom_Penh",
		"alternativeName": "Indochina Time",
		"group": ["Asia/Phnom_Penh"],
		"continentName": "Asia",
		"countryName": "Cambodia",
		"mainCities": ["Phnom Penh", "Takeo", "Siem Reap", "Battambang"]
	},
	{
		"name": "Asia/Vientiane",
		"alternativeName": "Indochina Time",
		"group": ["Asia/Vientiane"],
		"continentName": "Asia",
		"countryName": "Laos",
		"mainCities": ["Vientiane", "Savannakhet", "Pakse", "Thakhèk"]
	},
	{
		"name": "Asia/Novosibirsk",
		"alternativeName": "Novosibirsk Time",
		"group": ["Asia/Barnaul", "Asia/Krasnoyarsk", "Asia/Novokuznetsk", "Asia/Novosibirsk", "Asia/Tomsk"],
		"continentName": "Europe",
		"countryName": "Russia",
		"mainCities": ["Novosibirsk", "Krasnoyarsk", "Barnaul", "Tomsk"]
	},
	{
		"name": "Asia/Jakarta",
		"alternativeName": "Western Indonesia Time",
		"group": ["Asia/Jakarta", "Asia/Pontianak"],
		"continentName": "Asia",
		"countryName": "Indonesia",
		"mainCities": ["Jakarta", "Surabaya", "Bekasi", "Bandung"]
	},
	{
		"name": "Antarctica/Casey",
		"alternativeName": "Australian Western Time",
		"group": ["Antarctica/Casey"],
		"continentName": "Antarctica",
		"countryName": "Antarctica",
		"mainCities": ["Casey"]
	},
	{
		"name": "Australia/Perth",
		"alternativeName": "Australian Western Time",
		"group": ["Australia/Perth", "Australia/West"],
		"continentName": "Oceania",
		"countryName": "Australia",
		"mainCities": ["Perth", "Mandurah", "Bunbury", "Geraldton"]
	},
	{
		"name": "Asia/Brunei",
		"alternativeName": "Brunei Time",
		"group": ["Asia/Brunei"],
		"continentName": "Asia",
		"countryName": "Brunei",
		"mainCities": ["Bandar Seri Begawan", "Sengkurong", "Mentiri", "Kuala Belait"]
	},
	{
		"name": "Asia/Makassar",
		"alternativeName": "Central Indonesia Time",
		"group": ["Asia/Makassar", "Asia/Ujung_Pandang"],
		"continentName": "Asia",
		"countryName": "Indonesia",
		"mainCities": ["Makassar", "Samarinda", "Denpasar", "Balikpapan"]
	},
	{
		"name": "Asia/Macau",
		"alternativeName": "China Time",
		"group": ["Asia/Macau", "Asia/Macao"],
		"continentName": "Asia",
		"countryName": "Macao",
		"mainCities": ["Macau", "Taipa", "Sé", "Luhuan"]
	},
	{
		"name": "Asia/Shanghai",
		"alternativeName": "China Time",
		"group": ["Asia/Shanghai", "PRC", "Asia/Chongqing", "Asia/Harbin", "Asia/Chungking"],
		"continentName": "Asia",
		"countryName": "China",
		"mainCities": ["Shanghai", "Beijing", "Shenzhen", "Guangzhou"]
	},
	{
		"name": "Asia/Hong_Kong",
		"alternativeName": "Hong Kong Time",
		"group": ["Asia/Hong_Kong", "Hongkong"],
		"continentName": "Asia",
		"countryName": "Hong Kong",
		"mainCities": ["Hong Kong", "New Territories", "Kowloon", "Hong Kong Island"]
	},
	{
		"name": "Asia/Irkutsk",
		"alternativeName": "Irkutsk Time",
		"group": ["Asia/Irkutsk"],
		"continentName": "Europe",
		"countryName": "Russia",
		"mainCities": ["Irkutsk", "Ulan-Ude", "Bratsk", "Angarsk"]
	},
	{
		"name": "Asia/Kuala_Lumpur",
		"alternativeName": "Malaysia Time",
		"group": ["Asia/Kuala_Lumpur", "Asia/Kuching", "Asia/Brunei"],
		"continentName": "Asia",
		"countryName": "Malaysia",
		"mainCities": ["Kuala Lumpur", "Johor Bahru", "Kampung Baru Subang", "Petaling Jaya"]
	},
	{
		"name": "Asia/Manila",
		"alternativeName": "Philippine Time",
		"group": ["Asia/Manila"],
		"continentName": "Asia",
		"countryName": "Philippines",
		"mainCities": ["Quezon City", "Davao", "Caloocan City", "Manila"]
	},
	{
		"name": "Asia/Singapore",
		"alternativeName": "Singapore Time",
		"group": ["Asia/Singapore", "Singapore", "Asia/Kuala_Lumpur"],
		"continentName": "Asia",
		"countryName": "Singapore",
		"mainCities": ["Singapore", "Ulu Bedok", "Bedok New Town", "Tampines Estate"]
	},
	{
		"name": "Asia/Taipei",
		"alternativeName": "Taiwan Time",
		"group": ["Asia/Taipei", "ROC"],
		"continentName": "Asia",
		"countryName": "Taiwan",
		"mainCities": ["Taipei", "New Taipei City", "Taichung", "Kaohsiung"]
	},
	{
		"name": "Asia/Ulaanbaatar",
		"alternativeName": "Ulaanbaatar Time",
		"group": ["Asia/Ulaanbaatar", "Asia/Choibalsan", "Asia/Ulan_Bator"],
		"continentName": "Asia",
		"countryName": "Mongolia",
		"mainCities": ["Ulan Bator", "Erdenet", "Darhan", "Choibalsan"]
	},
	{
		"name": "Australia/Eucla",
		"alternativeName": "Australian Central Western Time",
		"group": ["Australia/Eucla"],
		"continentName": "Oceania",
		"countryName": "Australia",
		"mainCities": ["Eucla"]
	},
	{
		"name": "Asia/Jayapura",
		"alternativeName": "Eastern Indonesia Time",
		"group": ["Asia/Jayapura"],
		"continentName": "Asia",
		"countryName": "Indonesia",
		"mainCities": ["Jayapura", "Ambon", "Sorong", "Ternate"]
	},
	{
		"name": "Asia/Tokyo",
		"alternativeName": "Japan Time",
		"group": ["Asia/Tokyo", "Japan"],
		"continentName": "Asia",
		"countryName": "Japan",
		"mainCities": ["Tokyo", "Yokohama", "Osaka", "Nagoya"]
	},
	{
		"name": "Asia/Pyongyang",
		"alternativeName": "Korean Time",
		"group": ["Asia/Pyongyang"],
		"continentName": "Asia",
		"countryName": "North Korea",
		"mainCities": ["Pyongyang", "Hamhŭng", "Namp’o", "Sunch’ŏn"]
	},
	{
		"name": "Asia/Seoul",
		"alternativeName": "Korean Time",
		"group": ["Asia/Seoul", "ROK"],
		"continentName": "Asia",
		"countryName": "South Korea",
		"mainCities": ["Seoul", "Busan", "Incheon", "Daegu"]
	},
	{
		"name": "Pacific/Palau",
		"alternativeName": "Palau Time",
		"group": ["Pacific/Palau"],
		"continentName": "Oceania",
		"countryName": "Palau",
		"mainCities": ["Ngerulmud"]
	},
	{
		"name": "Asia/Dili",
		"alternativeName": "Timor-Leste Time",
		"group": ["Asia/Dili"],
		"continentName": "Oceania",
		"countryName": "Timor Leste",
		"mainCities": ["Dili", "Maliana", "Suai", "Likisá"]
	},
	{
		"name": "Asia/Chita",
		"alternativeName": "Yakutsk Time",
		"group": ["Asia/Chita", "Asia/Khandyga", "Asia/Yakutsk"],
		"continentName": "Europe",
		"countryName": "Russia",
		"mainCities": ["Chita", "Yakutsk", "Blagoveshchensk", "Belogorsk"]
	},
	{
		"name": "Australia/Adelaide",
		"alternativeName": "Australian Central Time",
		"group": ["Australia/Adelaide", "Australia/Broken_Hill", "Australia/South", "Australia/Yancowinna"],
		"continentName": "Oceania",
		"countryName": "Australia",
		"mainCities": ["Adelaide", "Adelaide Hills", "Mount Gambier", "Morphett Vale"]
	},
	{
		"name": "Australia/Darwin",
		"alternativeName": "Australian Central Time",
		"group": ["Australia/Darwin", "Australia/North"],
		"continentName": "Oceania",
		"countryName": "Australia",
		"mainCities": ["Darwin", "Palmerston", "Alice Springs"]
	},
	{
		"name": "Australia/Brisbane",
		"alternativeName": "Australian Eastern Time",
		"group": ["Australia/Brisbane", "Australia/Lindeman", "Australia/Queensland"],
		"continentName": "Oceania",
		"countryName": "Australia",
		"mainCities": ["Brisbane", "Gold Coast", "Sunshine Coast", "Logan City"]
	},
	{
		"name": "Australia/Sydney",
		"alternativeName": "Australian Eastern Time",
		"group": [
			"Antarctica/Macquarie",
			"Australia/Hobart",
			"Australia/Melbourne",
			"Australia/Sydney",
			"Australia/Tasmania",
			"Australia/Currie",
			"Australia/Victoria",
			"Australia/ACT",
			"Australia/NSW",
			"Australia/Canberra"
		],
		"continentName": "Oceania",
		"countryName": "Australia",
		"mainCities": ["Sydney", "Melbourne", "Newcastle", "Canberra"]
	},
	{
		"name": "Pacific/Guam",
		"alternativeName": "Chamorro Time",
		"group": ["Pacific/Guam", "Pacific/Saipan"],
		"continentName": "Oceania",
		"countryName": "Guam",
		"mainCities": ["Dededo Village", "Yigo Village", "Tamuning-Tumon-Harmon Village", "Tamuning"]
	},
	{
		"name": "Pacific/Saipan",
		"alternativeName": "Chamorro Time",
		"group": ["Pacific/Saipan"],
		"continentName": "Oceania",
		"countryName": "Northern Mariana Islands",
		"mainCities": ["Saipan"]
	},
	{
		"name": "Pacific/Chuuk",
		"alternativeName": "Chuuk Time",
		"group": ["Pacific/Chuuk"],
		"continentName": "Oceania",
		"countryName": "Micronesia",
		"mainCities": ["Chuuk"]
	},
	{
		"name": "Antarctica/DumontDUrville",
		"alternativeName": "Dumont d’Urville Time",
		"group": ["Antarctica/DumontDUrville"],
		"continentName": "Antarctica",
		"countryName": "Antarctica",
		"mainCities": ["DumontDUrville"]
	},
	{
		"name": "Pacific/Port_Moresby",
		"alternativeName": "Papua New Guinea Time",
		"group": ["Pacific/Port_Moresby", "Antarctica/DumontDUrville", "Pacific/Chuuk", "Pacific/Yap", "Pacific/Truk"],
		"continentName": "Oceania",
		"countryName": "Papua New Guinea",
		"mainCities": ["Port Moresby", "Lae", "Mount Hagen", "Popondetta"]
	},
	{
		"name": "Asia/Vladivostok",
		"alternativeName": "Vladivostok Time",
		"group": ["Asia/Ust-Nera", "Asia/Vladivostok"],
		"continentName": "Europe",
		"countryName": "Russia",
		"mainCities": ["Khabarovsk", "Vladivostok", "Khabarovsk Vtoroy", "Komsomolsk-on-Amur"]
	},
	{
		"name": "Australia/Lord_Howe",
		"alternativeName": "Lord Howe Time",
		"group": ["Australia/Lord_Howe", "Australia/LHI"],
		"continentName": "Oceania",
		"countryName": "Australia",
		"mainCities": ["Lord Howe"]
	},
	{
		"name": "Pacific/Bougainville",
		"alternativeName": "Bougainville Time",
		"group": ["Pacific/Bougainville"],
		"continentName": "Oceania",
		"countryName": "Papua New Guinea",
		"mainCities": ["Arawa"]
	},
	{
		"name": "Pacific/Kosrae",
		"alternativeName": "Kosrae Time",
		"group": ["Pacific/Kosrae", "Pacific/Pohnpei"],
		"continentName": "Oceania",
		"countryName": "Micronesia",
		"mainCities": ["Kosrae", "Palikir"]
	},
	{
		"name": "Pacific/Noumea",
		"alternativeName": "New Caledonia Time",
		"group": ["Pacific/Noumea"],
		"continentName": "Oceania",
		"countryName": "New Caledonia",
		"mainCities": ["Nouméa", "Mont-Dore", "Dumbéa"]
	},
	{
		"name": "Pacific/Norfolk",
		"alternativeName": "Norfolk Island Time",
		"group": ["Pacific/Norfolk"],
		"continentName": "Oceania",
		"countryName": "Norfolk Island",
		"mainCities": ["Kingston"]
	},
	{
		"name": "Asia/Sakhalin",
		"alternativeName": "Sakhalin Time",
		"group": ["Asia/Magadan", "Asia/Sakhalin", "Asia/Srednekolymsk"],
		"continentName": "Europe",
		"countryName": "Russia",
		"mainCities": ["Yuzhno-Sakhalinsk", "Magadan", "Korsakov", "Kholmsk"]
	},
	{
		"name": "Pacific/Guadalcanal",
		"alternativeName": "Solomon Islands Time",
		"group": ["Pacific/Guadalcanal", "Pacific/Pohnpei", "Pacific/Ponape"],
		"continentName": "Oceania",
		"countryName": "Solomon Islands",
		"mainCities": ["Honiara", "Panatina", "Nggosi", "Tandai"]
	},
	{
		"name": "Pacific/Efate",
		"alternativeName": "Vanuatu Time",
		"group": ["Pacific/Efate"],
		"continentName": "Oceania",
		"countryName": "Vanuatu",
		"mainCities": ["Port-Vila"]
	},
	{
		"name": "Pacific/Fiji",
		"alternativeName": "Fiji Time",
		"group": ["Pacific/Fiji"],
		"continentName": "Oceania",
		"countryName": "Fiji",
		"mainCities": ["Nasinu", "Suva", "Lautoka", "Nadi"]
	},
	{
		"name": "Pacific/Tarawa",
		"alternativeName": "Gilbert Islands Time",
		"group": ["Pacific/Tarawa", "Pacific/Funafuti", "Pacific/Majuro", "Pacific/Wake", "Pacific/Wallis"],
		"continentName": "Oceania",
		"countryName": "Kiribati",
		"mainCities": ["Tarawa"]
	},
	{
		"name": "Asia/Kamchatka",
		"alternativeName": "Kamchatka Time",
		"group": ["Asia/Anadyr", "Asia/Kamchatka"],
		"continentName": "Europe",
		"countryName": "Russia",
		"mainCities": ["Petropavlovsk-Kamchatsky", "Yelizovo", "Vilyuchinsk", "Anadyr"]
	},
	{
		"name": "Pacific/Majuro",
		"alternativeName": "Marshall Islands Time",
		"group": ["Pacific/Kwajalein", "Pacific/Majuro", "Kwajalein"],
		"continentName": "Oceania",
		"countryName": "Marshall Islands",
		"mainCities": ["Majuro", "Kwajalein"]
	},
	{
		"name": "Pacific/Nauru",
		"alternativeName": "Nauru Time",
		"group": ["Pacific/Nauru"],
		"continentName": "Oceania",
		"countryName": "Nauru",
		"mainCities": ["Yaren"]
	},
	{
		"name": "Pacific/Auckland",
		"alternativeName": "New Zealand Time",
		"group": ["Pacific/Auckland", "NZ", "Antarctica/McMurdo", "Antarctica/South_Pole"],
		"continentName": "Oceania",
		"countryName": "New Zealand",
		"mainCities": ["Auckland", "Christchurch", "Wellington", "Manukau City"]
	},
	{
		"name": "Antarctica/McMurdo",
		"alternativeName": "New Zealand Time",
		"group": ["Antarctica/McMurdo"],
		"continentName": "Antarctica",
		"countryName": "Antarctica",
		"mainCities": ["McMurdo"]
	},
	{
		"name": "Pacific/Funafuti",
		"alternativeName": "Tuvalu Time",
		"group": ["Pacific/Funafuti"],
		"continentName": "Oceania",
		"countryName": "Tuvalu",
		"mainCities": ["Funafuti"]
	},
	{
		"name": "Pacific/Wake",
		"alternativeName": "Wake Island Time",
		"group": ["Pacific/Wake"],
		"continentName": "Oceania",
		"countryName": "United States Minor Outlying Islands",
		"mainCities": ["Wake"]
	},
	{
		"name": "Pacific/Wallis",
		"alternativeName": "Wallis & Futuna Time",
		"group": ["Pacific/Wallis"],
		"continentName": "Oceania",
		"countryName": "Wallis and Futuna",
		"mainCities": ["Mata-Utu"]
	},
	{
		"name": "Pacific/Chatham",
		"alternativeName": "Chatham Time",
		"group": ["Pacific/Chatham", "NZ-CHAT"],
		"continentName": "Oceania",
		"countryName": "New Zealand",
		"mainCities": ["Chatham"]
	},
	{
		"name": "Pacific/Kanton",
		"alternativeName": "Phoenix Islands Time",
		"group": ["Pacific/Kanton", "Pacific/Enderbury"],
		"continentName": "Oceania",
		"countryName": "Kiribati",
		"mainCities": ["Kanton"]
	},
	{
		"name": "Pacific/Apia",
		"alternativeName": "Samoa Time",
		"group": ["Pacific/Apia"],
		"continentName": "Oceania",
		"countryName": "Samoa",
		"mainCities": ["Apia"]
	},
	{
		"name": "Pacific/Fakaofo",
		"alternativeName": "Tokelau Time",
		"group": ["Pacific/Fakaofo"],
		"continentName": "Oceania",
		"countryName": "Tokelau",
		"mainCities": ["Fakaofo"]
	},
	{
		"name": "Pacific/Tongatapu",
		"alternativeName": "Tonga Time",
		"group": ["Pacific/Tongatapu"],
		"continentName": "Oceania",
		"countryName": "Tonga",
		"mainCities": ["Nuku‘alofa"]
	},
	{
		"name": "Pacific/Kiritimati",
		"alternativeName": "Line Islands Time",
		"group": ["Pacific/Kiritimati"],
		"continentName": "Oceania",
		"countryName": "Kiribati",
		"mainCities": ["Kiritimati"]
	}
]
